module.exports = __webpack_public_path__ + "static/Boxed-logo-c9a8687a15b1ed2d0beb13eeaa821ec5.svg";